import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.js';
import { AuthProvider } from './features/auth/AuthProvider.js';
import { ThemeProvider } from './app/ThemeProvider.js';
import './styles/globals.css';
import { captureInstallPrompt } from './lib/pwa.js';

captureInstallPrompt();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>,
);
